// Constants file

const GOOGLE_API_KEY = process.env.NODE_ENV==='production'? process.env.REACT_APP_GOOGLE_API_KEY : '';
const HASURA_GRAPHQL_ENGINE_HOSTNAME = 'graphql.thinair.co';

const scheme = (proto) => {
  return window.location.protocol === 'https:' ? `${proto}s` : proto;
}

const wsurl = `${scheme('ws')}://${HASURA_GRAPHQL_ENGINE_HOSTNAME}/v1/graphql`;
const httpurl = `${scheme('http')}://${HASURA_GRAPHQL_ENGINE_HOSTNAME}/v1/graphql`;

// Valhalla routing engine for road map-matching
const VALHALLA_BASE_URL = process.env.REACT_APP_VALHALLA_URL || 'https://route.thinair.co';

// Expected GPS update interval in ms (used for gap detection + waypoint spacing)
const GPS_UPDATE_INTERVAL_MS = Number(process.env.REACT_APP_GPS_INTERVAL_MS) || 3000;

// Max gap duration we'll fill with Valhalla road geometry (default 5 minutes)
const MAX_GAP_DURATION_MS = Number(process.env.REACT_APP_MAX_GAP_DURATION_MS) || 5 * 60 * 1000;

// Min gap duration before we bother filling (default 2x the GPS interval)
const MIN_GAP_DURATION_MS = Number(process.env.REACT_APP_MIN_GAP_DURATION_MS) || GPS_UPDATE_INTERVAL_MS * 2;

export {
  GOOGLE_API_KEY,
  wsurl,
  httpurl,
  VALHALLA_BASE_URL,
  GPS_UPDATE_INTERVAL_MS,
  MAX_GAP_DURATION_MS,
  MIN_GAP_DURATION_MS,
};
